
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { type UserFieldConfig } from '@xt/client/entities/kindred-spirit/kindred-spirit'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop({ default: 0 }) process!: number
  @Prop() formList!: Array<UserFieldConfig>

  @Emit('to-sub')
  toSub(key: string) {
    return key
  }

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
